module.exports = __webpack_public_path__ + "img/jgdw.6fb8eb77.png";